import { render, staticRenderFns } from "./Node.vue?vue&type=template&id=a56d2438&scoped=true&"
import script from "./Node.vue?vue&type=script&lang=js&"
export * from "./Node.vue?vue&type=script&lang=js&"
import style0 from "./Node.vue?vue&type=style&index=0&id=a56d2438&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"
import style1 from "./Node.vue?vue&type=style&index=1&id=a56d2438&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56d2438",
  null
  
)

export default component.exports